import { Component, OnInit, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MasterDataService } from 'src/app/services/master-data.service';
import { PenaltySummaryDetailModel } from './penalty-summary.model';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';


@Component({
  selector: 'app-penalty-summary',
  templateUrl: './penalty-summary.component.html',
  styleUrls: ['./penalty-summary.component.css'],
})
export class PenaltySummaryComponent implements OnInit {
  userId = 0;
  branchList;
  roleList;
  financialList;
  closingDateList;
  selectedFinancialYear;
  selectedRole;
  selectedBranch;
  selectedClosing;
  isRoleSelected = false;
  isBranchSelected = false;
  isClosingDateSelected = false;
  @Input() closingDateId;
  approvalPenaltyDetailsList;
  submissionPenaltyDetailsList;
  lateLeaveApplicationPenaltyDetailsList;
  lateLeaveApprovalPenaltyDetailsList;
  showApprovalPenaltyData = true;
  showSubmissionPenaltyData = true;
  showLateLeaveApplicationPenaltyData = true;
  showLateLeaveApprovalPenaltyData = true;
  approvalPenaltyTotal;
  submissionPenaltyTotal;
  lateLeaveApplPenaltyTotal;
  lateLeaveApprovalPenaltyTotal;
  allLastDaysTotal;
  userRole;
  accessResponse: any;

  @Input() reportList = [];
  @Input() isMyReport: boolean;
  constructor(private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectedClosing = "";
    if (!this.isMyReport) {
      this.loadInitDetails();
    }
  }
  loadInitDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
    this.masterDataService.getRoles().subscribe((res) => {
      this.roleList = res;
    });
  }

  onFinancialYearSlected() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined && this.selectedFinancialYear != ""
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          console.log('closing list', res);
          var notClosedobject = {
            id: 0,
            closingDate: "Not Closed"
          }
          this.closingDateList.push(notClosedobject)
          console.log('closing list', res);
        });
    }
  }

  showExportToExcelButton: boolean;
  onViewReport() {
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == "" ||
      this.selectedClosing == null ||
      this.selectedClosing == "" ||
      this.selectedBranch == null ||
      this.selectedBranch.length === 0 ||
      this.selectedRole == null ||
      this.selectedRole.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    console.log('Report,called');
    const branchId = this.selectedBranch.map(({ id }) => id);
    const roleId = this.selectedRole.map(({ id }) => id);
    this.masterDataService
      .getPanaltySummary(branchId, roleId, this.selectedClosing, this.userId)
      .subscribe((res) => {
        //this.reportList =res[0].role;
        this.reportList = res;
        console.log('reportlist........', res);
        if (this.reportList.length == 0) {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Records Found');
          this.showExportToExcelButton = false;
        } else {
          this.showExportToExcelButton = true;
        }
      });
    // this.masterDataService.getSalaryReport(this.selectedBranch.id, this.selectedClosing, this.selectedProfile, this.selectedDesignation)
    //   .subscribe(res => {
    //     this.reportList = res;
    //   });
  }

  exportToExcelClick() {
    const branchId = this.selectedBranch.map(({ id }) => id);
    const roleId = this.selectedRole.map(({ id }) => id);
    this.masterDataService.getPenaltySummaryReportExportToExcel(branchId, roleId, this.selectedClosing, this.userId).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "PenaltySummaryReport.xlsx";
      link.click();
    })
  }

  selectAllRole(select: NgModel, values) {
    this.selectAll(select, values, this.isRoleSelected, false);
    this.isRoleSelected = !this.isRoleSelected;
  }
  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
  }
  selectAllClosingDate(select: NgModel, values) {
    console.log('selectAllClosingDate');
    this.selectAllClosing(select, values, this.isClosingDateSelected);
    this.isClosingDateSelected = !this.isClosingDateSelected;
  }
  selectAllClosing(select: NgModel, values, isSelected) {
    if (!isSelected) {
      const selectedIds = values.map(value => value.id); // Extract only the IDs
      select.update.emit(selectedIds);
    } else {
      select.update.emit([]); // Clear selection
    }
  }

  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  getApprovalTotal(detail: PenaltySummaryDetailModel[]) {
    const lateApprovalsum = detail
      .map((a) => a.lateApproval)
      .reduce((a, b) => a + b, 0);
    return lateApprovalsum;
  }
  getLateSubmissionTotal(detail: PenaltySummaryDetailModel[]) {
    const sum = detail.map((a) => a.lateSubmission).reduce((a, b) => a + b, 0);
    return sum;
  }
  getLateLeaveTotal(detail: PenaltySummaryDetailModel[]) {
    const sum = detail.map((a) => a.lateLeaveApply).reduce((a, b) => a + b, 0);
    return sum;
  }
  getLeaveApprovalTotal(detail: PenaltySummaryDetailModel[]) {
    const sum = detail
      .map((a) => a.lateLeaveApproval)
      .reduce((a, b) => a + b, 0);
    return sum;
  }
  getPenaltyTotal(detail: PenaltySummaryDetailModel) {
    const sum =
      detail.lateApproval +
      detail.lateLeaveApply +
      detail.lateLeaveApproval +
      detail.lateSubmission;
    return sum;
  }
  getPenaltiesTotal(detail: PenaltySummaryDetailModel[]) {
    const sum = detail
      .map(
        (a) =>
          a.lateApproval +
          a.lateLeaveApply +
          a.lateLeaveApproval +
          a.lateSubmission
      )
      .reduce((a, b) => a + b, 0);
    return sum;
  }

  // Approval Penalty
  diaryApprovalId;
  getApprovalPenaltyDetails(userId, closingDate) {
    this.diaryApprovalId = userId;

    if (!this.isMyReport) {
      if (closingDate != null) {
        closingDate = this.formatDate(closingDate)
        console.log('getApprovalPenaltyDetails', closingDate);
        this.closingDateId = this.closingDateList.find(date => this.formatDate(date.closingDate) === closingDate) || null;
        this.closingDateId = this.closingDateId.id;
        console.log('id closing date', this.closingDateId);
      } else {
        this.closingDateId = 0;
      }
    }
    this.masterDataService
      .getApprovalPenalty(userId, this.closingDateId)
      .subscribe((res) => {
        this.approvalPenaltyDetailsList = res;
        console.log('approvalPenaltyDetailsList', this.approvalPenaltyDetailsList);
        if (this.approvalPenaltyDetailsList != null) {
          this.showApprovalPenaltyData = false;
          this.allPenaltyTotal();
        }
      });
  }

  exportToExcelDiaryApprovalPenalty() {
    this.masterDataService
      .getApprovalPenaltyExportToExcel(this.diaryApprovalId, this.closingDateId)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "DiaryApprovalPenaltyReport.xlsx";
        link.click();
      });
  }

  getRowSpanForPenalty(detailList) {
    var count = 1;
    detailList.map((res) => {
      res.weekDetails.map((data) => {
        count++;
      });
    });
    return count;
  }

  calculateApprovalTotal(detailList) {
    var penaltyAmount = 0;
    detailList.map((res) => {
      res.weekDetails.map((data) => {
        penaltyAmount += data.penaltyAmount;
      });
    });
    return penaltyAmount;
  }


  private formatDate(date: string | Date): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }


  // Submission Penalty
  diarySubmissionUserId;
  getSubmissionPenaltyDetails(userId, closingDate) {
    this.diarySubmissionUserId = userId;
    console.log(closingDate);
    if (!this.isMyReport) {
      if (closingDate != null) {
        closingDate = this.formatDate(closingDate)
        console.log('getSubmissionPenaltyDetails', closingDate);
        this.closingDateId = this.closingDateList.find(date => this.formatDate(date.closingDate) === closingDate) || null;
        this.closingDateId = this.closingDateId.id;
        console.log('id closing date', this.closingDateId);
      } else {
        this.closingDateId = 0;
      }
    }

    this.masterDataService
      .getSubmissionPenalty(userId, this.closingDateId)
      .subscribe((res) => {
        this.submissionPenaltyDetailsList = res;
        console.log(
          'submission penalty details',
          this.submissionPenaltyDetailsList
        );
        if (this.submissionPenaltyDetailsList != null) {
          this.showSubmissionPenaltyData = false;
          this.allSubmissionPenaltyTotal();
        }
      });
  }

  exportToExcelDiarySubmissionPenalty() {
    this.masterDataService
      .getSubmissionPenaltyExportToExcel(this.diarySubmissionUserId, this.closingDateId)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "DiarySubmissionPenaltyReport.xlsx";
        link.click();
      });
  }

  getRowSpanSubmissionPenalty(detailList) {
    var count = 1;
    detailList.weekDetails.map((res) => {
      count++;
    });
    return count;
  }

  calculateSubmissionTotal(detailList) {
    var submissionPenaltyAmount = 0;
    detailList.weekDetails.map((res) => {
      submissionPenaltyAmount += res.penaltyAmount;
    });
    return submissionPenaltyAmount;
  }

  //Late Leave Penalty
  lateLeaveApplUserId;
  getLateLeaveApplicationPenaltyDetails(userId, closingDate) {
    this.lateLeaveApplUserId = userId;
    if (!this.isMyReport) {
      if (closingDate != null) {
        closingDate = this.formatDate(closingDate)
        console.log('getLateLeaveApplicationPenaltyDetails', closingDate);
        this.closingDateId = this.closingDateList.find(date => this.formatDate(date.closingDate) === closingDate) || null;
        this.closingDateId = this.closingDateId.id;
        console.log('id closing date', this.closingDateId);
      } else {
        this.closingDateId = 0;
      }
    }
    this.masterDataService
      .getLateLeaveApplicationPenalty(userId, this.closingDateId)
      .subscribe((res) => {
        this.lateLeaveApplicationPenaltyDetailsList = res;
        if (this.lateLeaveApplicationPenaltyDetailsList != null) {
          this.showLateLeaveApplicationPenaltyData = false;
          this.allLateLeaveApplPenaltyTotal();
        }
      });
  }

  exportToExcelLateLeaveApplicationPenalty() {
    this.masterDataService
      .getLateLeaveApplicationExportToExcelPenalty(this.lateLeaveApplUserId, this.closingDateId)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "LateLeaveApplicationPenaltyReport.xlsx";
        link.click();
      });
  }
  getRowSpanLateLeaveApplPenalty(detailList) {
    var count = 1;
    detailList.weekDetails.map((res) => {
      count++;
    });
    return count;
  }

  calculateLateDaysTotal(detailList) {
    var lateDaysTotal = 0;
    detailList.weekDetails.map((res) => {
      lateDaysTotal += res.lateDays;
    });
    return lateDaysTotal;
  }

  calculateLateLeaveApplTotal(detailList) {
    var lateLeaveApplPenaltyAmount = 0;
    detailList.weekDetails.map((res) => {
      lateLeaveApplPenaltyAmount += res.penaltyAmount;
    });
    return lateLeaveApplPenaltyAmount;
  }

  //Late Leave Approval Penalty
  lateLeaveApprovalUserId;
  getLateLeaveApprovalPenaltyDetails(userId, closingDate) {
    this.lateLeaveApprovalUserId = userId;

    if (!this.isMyReport) {
      if (closingDate != null) {
        closingDate = this.formatDate(closingDate)
        console.log('getLateLeaveApprovalPenaltyDetails', closingDate);
        this.closingDateId = this.closingDateList.find(date => this.formatDate(date.closingDate) === closingDate) || null;
        this.closingDateId = this.closingDateId.id;
        console.log('id closing date', this.closingDateId);
      } else {
        this.closingDateId = 0;
      }
    }
    this.masterDataService
      .getLateLeaveApprovalPenalty(userId, this.closingDateId)
      .subscribe((res) => {

        this.lateLeaveApprovalPenaltyDetailsList = res;
        console.log('this.lateLeaveApprovalPenaltyDetailsList', this.lateLeaveApprovalPenaltyDetailsList);
        if (this.lateLeaveApprovalPenaltyDetailsList != null) {
          this.showLateLeaveApprovalPenaltyData = false;
          this.allLateLeaveApprovalPenaltyTotal();
        }
      });
  }

  exportToExcelLateLeaveApprovalPenalty() {
    this.masterDataService
      .getLateLeaveApprovalExportToExcelPenalty(this.lateLeaveApprovalUserId, this.closingDateId)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "LateLeaveApprovalPenaltyReport.xlsx";
        link.click();
      });
  }

  getRowSpanLateLeaveApprovalPenalty(detailList) {
    var count = 1;
    detailList.map((res) => {
      res.weekDetails.map((data) => {
        count++;
      });
    });
    return count;
  }

  calculateLateLeaveApprovalTotal(detailList) {
    var lateLeaveApprovalPenaltyAmount = 0;
    detailList.map((res) => {
      res.weekDetails.map((data) => {
        lateLeaveApprovalPenaltyAmount += data.penaltyAmount;
      });
    });
    return lateLeaveApprovalPenaltyAmount;
  }

  goBack() {
    this.showApprovalPenaltyData = true;
    this.showSubmissionPenaltyData = true;
    this.showLateLeaveApplicationPenaltyData = true;
    this.showLateLeaveApprovalPenaltyData = true;
  }

  allPenaltyTotal() {
    var penaltyAmount = 0;
    this.approvalPenaltyDetailsList.penaltyDetails.map((res) => {
      res.details.map((data) => {
        data.weekDetails.map((item) => {
          penaltyAmount += item.penaltyAmount;
        });
      });
    });
    this.approvalPenaltyTotal = penaltyAmount;
  }

  allSubmissionPenaltyTotal() {
    var penaltyAmount = 0;
    this.submissionPenaltyDetailsList.penaltyDetails.map((data) => {
      data.weekDetails.map((item) => {
        penaltyAmount += item.penaltyAmount;
      });
    });
    this.submissionPenaltyTotal = penaltyAmount;
  }

  allLateLeaveApplPenaltyTotal() {
    var penaltyAmount = 0;
    var lateDays = 0;
    this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails.map((data) => {
      data.weekDetails.map((item) => {
        penaltyAmount += item.penaltyAmount;
        lateDays += item.lateDays;
      });
    });
    this.lateLeaveApplPenaltyTotal = penaltyAmount;
    this.allLastDaysTotal = lateDays;
  }

  allLateLeaveApprovalPenaltyTotal() {
    var penaltyAmount = 0;
    this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails.map((res) => {
      res.details.map((data) => {
        data.weekDetails.map((item) => {
          penaltyAmount += item.penaltyAmount;
        });
      });
    });
    this.lateLeaveApprovalPenaltyTotal = penaltyAmount;
  }

  exportToPDFClick() {
    var docDefinition = {
      info: { title: 'Penalty Summary Report' },
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Penalty summary', fontSize: 14, bold: true, alignment: 'center', margin: [0, 10, 0, 5] });

    for (let i = 0; i < this.reportList.length; i++) {
      var totalPenalty = 0;
      var totalLateApproval = 0;
      var totalLateLeaveApply = 0;
      var totalLateLeaveApproval = 0;
      var totalLateSubmission = 0;
      this.reportList[i].penaltyDetails.map(res => {
        totalLateApproval += res.lateApproval;
        totalLateLeaveApply += res.lateLeaveApply;
        totalLateLeaveApproval += res.lateLeaveApproval;
        totalLateSubmission += res.lateSubmission;
        totalPenalty = (totalPenalty + res.lateApproval + res.lateLeaveApply + res.lateLeaveApproval + res.lateSubmission);
      });
      docDefinition.content.push(' ');
      //docDefinition.content.push({ columns: [{ text: `Closing Date:${this.reportList[i].closingDate}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] }] });
      const closingDate = this.reportList[i].closingDate
        ? new Date(this.reportList[i].closingDate).toISOString().split('T')[0].split('-').reverse().join('-')
        : 'Not Closed';

      docDefinition.content.push({
        columns: [{ text: `Closing Date: ${closingDate}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] }]
      });

      docDefinition.content.push({ columns: [{ text: `Role:${this.reportList[i].role}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] }, { text: `Branch:${this.reportList[i].branch}`, fontSize: 12, bold: true, margin: [250, 0, 0, 5] }] });
      docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: [200, '*', '*', '*', '*', '*'],
          body: [
            [{ text: 'Employee Name	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Approval Penalty', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Submission Penalty', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Late Leave Application Penalty', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Late Leave Approval Penalty', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Total Penalty', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
            ...this.reportList[i].penaltyDetails.map(res => [{ text: `${res.firstName} ${res.middleName} ${res.lastName}` }, { text: `${res.lateApproval}` }, { text: `${res.lateSubmission}` }, { text: `${res.lateLeaveApply}` }, { text: `${res.lateLeaveApproval}` }, { text: `${(res.lateApproval + res.lateLeaveApply + res.lateLeaveApproval + res.lateSubmission)}` }]),
            [{ text: 'Total', bold: true, fillColor: '#e1f4f7' }, { text: `${totalLateApproval}`, fillColor: '#e1f4f7' }, { text: `${totalLateSubmission}`, fillColor: '#e1f4f7' }, { text: `${totalLateLeaveApply}`, fillColor: '#e1f4f7' }, { text: `${totalLateLeaveApproval}`, fillColor: '#e1f4f7' }, { text: `${totalPenalty}`, fillColor: '#e1f4f7' }]
          ]
        }
      }
      );
    }
    pdfMake.createPdf(docDefinition).download('PenaltySummaryReport.pdf');
  }

  exportToPDFDiaryApprovalPenalty() {
    var body = [];
    body.push([{ text: 'Penalty Date', style: 'headerStyle' }, { text: 'EmployeeName', style: 'headerStyle' }, { text: 'Week StartDate', style: 'headerStyle' }, { text: 'Week EndDate', style: 'headerStyle' }, { text: 'Week Status', style: 'headerStyle' }, { text: 'Submitted Date	', style: 'headerStyle' }, { text: 'Penalty Amount', style: 'headerStyle' }]);
    var allTotalAmount = 0;
    for (let i = 0; i < this.approvalPenaltyDetailsList.penaltyDetails.length; i++) {
      var taskSize = 1;
      for (let j = 0; j < this.approvalPenaltyDetailsList.penaltyDetails[i].details.length; j++) {
        taskSize = taskSize + this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails.length;
      }
      var totalDays = 0;
      for (let j = 0; j < this.approvalPenaltyDetailsList.penaltyDetails[i].details.length; j++) {
        for (let k = 0; k < this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails.length; k++) {
          console.log('tasksize', taskSize);
          var row = [
            { text: moment(this.approvalPenaltyDetailsList.penaltyDetails[i].penaltyDate).format('DD-MMM-YYYY'), rowSpan: taskSize },
            { text: `${this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].approveeFName} ${this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].approveeMName} ${this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].approveeLName}`, rowSpan: this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails.length },
            { text: moment(this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].weekStartDate).format('DD-MMM-YYYY') },
            { text: moment(this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].weekEndDate).format('DD-MMM-YYYY') },
            { text: this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].status },
            { text: moment(this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].submittedDate).format('DD-MMM-YYYY') },
            { text: this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].penaltyAmount },
          ]
          body.push(row)
          totalDays = totalDays + this.approvalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].penaltyAmount;
        }
      }
      var totalRow = []
      totalRow = ['', { text: 'Total', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${Math.round(totalDays)}`, fillColor: '#e1f4f7' }]
      body.push(totalRow)

      allTotalAmount = allTotalAmount + totalDays;
    }

    body.push([{ text: 'Total', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: `${Math.round(allTotalAmount)}`, style: 'alltotalStyle' }])

    console.log('rows array', body);
    let docDefinition = {
      info: { title: 'Approval Penalty Details' },
      pageOrientation: 'landscape',
      content: [
        { text: 'P G BHAGWAT LLP, Chartered Accountants', style: 'header' },
        { text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', style: 'header1' },
        { text: 'Approval Penalty Details', style: 'header2' },
        { text: `Closing Date : ${this.approvalPenaltyDetailsList.closingDate == null ? '' : moment(this.approvalPenaltyDetailsList.closingDate).format('DD-MMM-YYYY')}`, fontSize: 14, bold: true, alignment: 'center' },
        { text: `Approver Name : ${this.approvalPenaltyDetailsList.firstName} ${this.approvalPenaltyDetailsList.lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 10] },

        {
          table: {
            headerRows: 1,
            widths: ['*', 200, '*', '*', '*', '*', '*'],
            body: body
          },
          // layout: 'noBorders'
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
        },
        header1: {
          alignment: 'center',

        },
        header2: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 10, 0, 5],
        },
        header3: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        headerStyle: {
          fillColor: '#17a2b8 !important',
          color: 'white',
          margin: [8, 8, 8, 8],
          fontSize: 14,
          bold: true,
        },
        alltotalStyle: {
          fillColor: '#e1f4f7',
          margin: [0, 5, 0, 5],
        },
      }
    }
    pdfMake.createPdf(docDefinition).download('ApprovalPenalty.pdf');
  }


  exportToPDFLateLeaveApprovalPenalty() {
    var body = [];
    body.push([{ text: 'Penalty Date', style: 'headerStyle' }, { text: 'EmployeeName', style: 'headerStyle' }, { text: 'leave From Date	', style: 'headerStyle' }, { text: 'leave To Date	', style: 'headerStyle' }, { text: 'Status', style: 'headerStyle' }, { text: 'leave Request Date	', style: 'headerStyle' }, { text: 'Penalty Amount', style: 'headerStyle' }]);
    var allTotalAmount = 0;
    for (let i = 0; i < this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails.length; i++) {
      var taskSize = 1;
      for (let j = 0; j < this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details.length; j++) {
        taskSize = taskSize + this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails.length;
      }
      var totalDays = 0;
      for (let j = 0; j < this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details.length; j++) {
        for (let k = 0; k < this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails.length; k++) {
          console.log('tasksize', taskSize);
          var row = [
            { text: moment(this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].penaltyDate).format('DD-MMM-YYYY'), rowSpan: taskSize },
            { text: `${this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].approveeFName} ${this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].approveeMName} ${this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].approveeLName}`, rowSpan: this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails.length },
            { text: moment(this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].leaveFromDate).format('DD-MMM-YYYY') },
            { text: moment(this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].leaveToDate).format('DD-MMM-YYYY') },
            { text: this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].status },
            { text: moment(this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].leaveRequestDate).format('DD-MMM-YYYY') },
            { text: this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].penaltyAmount },
          ]
          body.push(row)
          totalDays = totalDays + this.lateLeaveApprovalPenaltyDetailsList.penaltyDetails[i].details[j].weekDetails[k].penaltyAmount;
        }
      }
      var totalRow = []
      totalRow = ['', { text: 'Total', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${Math.round(totalDays)}`, fillColor: '#e1f4f7' }]
      body.push(totalRow)

      allTotalAmount = allTotalAmount + totalDays;
    }

    body.push([{ text: 'Total', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: `${Math.round(allTotalAmount)}`, style: 'alltotalStyle' }])

    console.log('rows array', body);
    let docDefinition = {
      info: { title: 'Late Leave Approval Penalty Details' },
      pageOrientation: 'landscape',
      content: [
        { text: 'P G BHAGWAT LLP, Chartered Accountants', style: 'header' },
        { text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', style: 'header1' },
        { text: 'Late Leave Approval Penalty Details', style: 'header2' },
        { text: `Closing Date : ${this.lateLeaveApprovalPenaltyDetailsList.closingDate == null ? '' : moment(this.lateLeaveApprovalPenaltyDetailsList.closingDate).format('DD-MMM-YYYY')}`, fontSize: 14, bold: true, alignment: 'center' },
        { text: `Approver Name : ${this.lateLeaveApprovalPenaltyDetailsList.firstName} ${this.lateLeaveApprovalPenaltyDetailsList.lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 10] },

        {
          table: {
            headerRows: 1,
            widths: ['*', 200, '*', '*', '*', '*', '*'],
            body: body
          },
          // layout: 'noBorders'
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
        },
        header1: {
          alignment: 'center',

        },
        header2: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 10, 0, 5],
        },
        header3: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        headerStyle: {
          fillColor: '#17a2b8 !important',
          color: 'white',
          margin: [8, 8, 8, 8],
          fontSize: 14,
          bold: true,
        },
        alltotalStyle: {
          fillColor: '#e1f4f7',
          margin: [0, 5, 0, 5],
        },
      }
    }
    pdfMake.createPdf(docDefinition).download('LateLeaveApprovalPenalty.pdf');
  }

  exportToPDFSubmissionPenalty() {
    var body = [];
    body.push([{ text: 'Penalty Date', style: 'headerStyle' }, { text: 'Week StartDate		', style: 'headerStyle' }, { text: 'Week EndDate', style: 'headerStyle' }, { text: 'Week Status	', style: 'headerStyle' }, { text: 'Penalty Amount', style: 'headerStyle' }]);
    var allTotalAmount = 0;
    for (let i = 0; i < this.submissionPenaltyDetailsList.penaltyDetails.length; i++) {
      var taskSize = 0;
      var totalDays = 0;
      for (let k = 0; k < this.submissionPenaltyDetailsList.penaltyDetails[i].weekDetails.length; k++) {
        var row = [
          { text: moment(this.submissionPenaltyDetailsList.penaltyDetails[i].penaltyDate).format('DD-MMM-YYYY'), rowSpan: this.submissionPenaltyDetailsList.penaltyDetails[i].weekDetails.length + 1 },
          { text: moment(this.submissionPenaltyDetailsList.penaltyDetails[i].weekDetails[k].weekStartDate).format('DD-MMM-YYYY') },
          { text: moment(this.submissionPenaltyDetailsList.penaltyDetails[i].weekDetails[k].weekEndDate).format('DD-MMM-YYYY') },
          { text: this.submissionPenaltyDetailsList.penaltyDetails[i].weekDetails[k].status },
          { text: this.submissionPenaltyDetailsList.penaltyDetails[i].weekDetails[k].penaltyAmount },
        ]
        body.push(row)
        totalDays = totalDays + this.submissionPenaltyDetailsList.penaltyDetails[i].weekDetails[k].penaltyAmount;
      }
      var totalRow = []
      totalRow = ['', { text: 'Total', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${Math.round(totalDays)}`, fillColor: '#e1f4f7' }]
      body.push(totalRow)

      allTotalAmount = allTotalAmount + totalDays;
    }

    body.push([{ text: 'Total', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: `${Math.round(allTotalAmount)}`, style: 'alltotalStyle' }])

    console.log('rows array', body);
    let docDefinition = {
      info: { title: 'Submission Penalty Details' },
      pageOrientation: 'landscape',
      content: [
        { text: 'P G BHAGWAT LLP, Chartered Accountants', style: 'header' },
        { text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', style: 'header1' },
        { text: 'Submission Penalty Details', style: 'header2' },
        { text: `Closing Date : ${this.submissionPenaltyDetailsList.closingDate == null ? '' : moment(this.submissionPenaltyDetailsList.closingDate).format('DD-MMM-YYYY')}`, fontSize: 14, bold: true, alignment: 'center' },
        { text: `Approver Name : ${this.submissionPenaltyDetailsList.firstName} ${this.submissionPenaltyDetailsList.lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 10] },

        {
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*', '*'],
            body: body
          },
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
        },
        header1: {
          alignment: 'center',

        },
        header2: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 10, 0, 5],
        },
        header3: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        headerStyle: {
          fillColor: '#17a2b8 !important',
          color: 'white',
          margin: [8, 8, 8, 8],
          fontSize: 14,
          bold: true,
        },
        alltotalStyle: {
          fillColor: '#e1f4f7',
          margin: [0, 5, 0, 5],
        },
      }
    }
    pdfMake.createPdf(docDefinition).download('SubmissionPenalty.pdf');
  }

  exportToPDFLateLeaveApplPenalty() {
    var body = [];
    body.push([{ text: 'Penalty Date', style: 'headerStyle' }, { text: 'Leave Request Date', style: 'headerStyle' }, { text: 'Leave From Date', style: 'headerStyle' }, { text: '	Leave To Date', style: 'headerStyle' }, { text: 'Late Days	', style: 'headerStyle' }, { text: 'Penalty Amount', style: 'headerStyle' }]);
    var allTotalAmount = 0;
    var allTotalDays = 0;
    for (let i = 0; i < this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails.length; i++) {
      var totalDays = 0;
      var totalAmount = 0;
      for (let k = 0; k < this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails.length; k++) {
        var row = [
          { text: moment(this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].penaltyDate).format('DD-MMM-YYYY'), rowSpan: this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails.length + 1 },
          { text: moment(this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails[k].leaveRequestDate).format('DD-MMM-YYYY') },
          { text: moment(this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails[k].leaveFromDate).format('DD-MMM-YYYY') },
          { text: moment(this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails[k].leaveToDate).format('DD-MMM-YYYY') },
          { text: this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails[k].lateDays },
          { text: this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails[k].penaltyAmount },
        ]
        body.push(row)
        totalDays = totalDays + this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails[k].lateDays;
        totalAmount = totalAmount + this.lateLeaveApplicationPenaltyDetailsList.penaltyDetails[i].weekDetails[k].penaltyAmount;
      }
      var totalRow = []
      totalRow = ['', { text: 'Total', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: totalDays, fillColor: '#e1f4f7' }, { text: `${Math.round(totalAmount)}`, fillColor: '#e1f4f7' }]
      body.push(totalRow)
      allTotalDays = allTotalDays + totalDays;
      allTotalAmount = allTotalAmount + totalAmount;
    }

    body.push([{ text: 'Total', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: allTotalDays, style: 'alltotalStyle' }, { text: `${Math.round(allTotalAmount)}`, style: 'alltotalStyle' }])

    let docDefinition = {
      info: { title: 'Late Leave Application Penalty Details' },
      pageOrientation: 'landscape',
      content: [
        { text: 'P G BHAGWAT LLP, Chartered Accountants', style: 'header' },
        { text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', style: 'header1' },
        { text: 'Late Leave Application Penalty Details', style: 'header2' },
        { text: `Closing Date : ${this.lateLeaveApplicationPenaltyDetailsList.closingDate == null ? '' : moment(this.lateLeaveApplicationPenaltyDetailsList.closingDate).format('DD-MMM-YYYY')}`, fontSize: 14, bold: true, alignment: 'center' },
        { text: `Approver Name : ${this.lateLeaveApplicationPenaltyDetailsList.firstName} ${this.lateLeaveApplicationPenaltyDetailsList.lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 10] },

        {
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*', '*', '*'],
            body: body
          },
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
        },
        header1: {
          alignment: 'center',

        },
        header2: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 10, 0, 5],
        },
        header3: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        headerStyle: {
          fillColor: '#17a2b8 !important',
          color: 'white',
          margin: [8, 8, 8, 8],
          fontSize: 14,
          bold: true,
        },
        alltotalStyle: {
          fillColor: '#e1f4f7',
          margin: [0, 5, 0, 5],
        },
      }
    }
    pdfMake.createPdf(docDefinition).download('LateLeaveApplicationPenalty.pdf');
  }
}
